import React, { useEffect, useState } from 'react'

const DEFAULT_DELAY_BEFORE_LAUNCH = 0
const STATUS_WAITING = 'waiting'
const STATUS_READY = 'ready'

const DelayComponent = ({ children, delay = DEFAULT_DELAY_BEFORE_LAUNCH }) => {
  const [status, setStatus] = useState(STATUS_WAITING)

  useEffect(() => {
    const timeout = setTimeout(() => setStatus(STATUS_READY), delay)
    return () => {
      clearTimeout(timeout)
    }
  }, [])

  if (status !== STATUS_READY) return <></>
  return children
}

export default DelayComponent
